import React, { useContext } from 'react';

import AssetListContext from '../app/context/assetListContext';

const useAssetSearch = () => {
  const { filteredAssetList, assetFilters,assetList, updateFilteredAssetList } = useContext(AssetListContext);

  const handleSearch = (event) => {
    if(event) {
      event.preventDefault();
      let newAssetList = [];

      if (assetFilters.buildingFilter.length >0 || assetFilters.conditionFilter > 0) {
        newAssetList = filteredAssetList;
      } else {
        newAssetList = assetList;
      }


      updateFilteredAssetList(
        newAssetList.filter(assets => {

          return (
            assets.SerialNo.toString().toLowerCase().indexOf(event.target.value.toLowerCase()) >= 0 ||
            assets.ContractNo.toString().toLowerCase().indexOf(event.target.value.toLowerCase()) >= 0 ||
            assets.ContractSiteDesc.toString().toLowerCase().indexOf(event.target.value.toLowerCase()) >= 0 ||
            assets.CustomerCode.toString().toLowerCase().indexOf(event.target.value.toLowerCase()) >= 0 ||
            assets.ItemCode.toString().toLowerCase().indexOf(event.target.value.toLowerCase) >= 0 ||
            assets.ItemDescription.toString().toLowerCase().indexOf(event.target.value.toLowerCase()) >= 0
          )
        })
      )
    }
  };
  return {
    handleSearch,
  }
};

export default useAssetSearch;